import React from 'react';
import { MapPin, Navigation } from 'lucide-react';

const MapPinButton = ({ address, label = 'View on Map', variant = 'primary', size = 'sm' }) => {
  if (!address || address.trim() === '') {
    return null;
  }

  const openGoogleMaps = (e) => {
    e.stopPropagation();
    const encodedAddress = encodeURIComponent(address);
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(googleMapsUrl, '_blank', 'noopener,noreferrer');
  };

  const openNavigation = (e) => {
    e.stopPropagation();
    const encodedAddress = encodeURIComponent(address);
    const navigationUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;
    window.open(navigationUrl, '_blank', 'noopener,noreferrer');
  };

  const sizeClasses = {
    xs: 'px-2 py-1 text-xs',
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-4 py-2 text-sm',
    lg: 'px-5 py-2.5 text-base'
  };

  const iconSizes = {
    xs: 'h-3 w-3',
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-6 w-6'
  };

  const variantClasses = {
    primary: 'bg-blue-600 hover:bg-blue-700 text-white',
    secondary: 'bg-gray-600 hover:bg-gray-700 text-white',
    outline: 'border border-blue-600 text-blue-600 hover:bg-blue-50',
    ghost: 'text-blue-600 hover:bg-blue-50'
  };

  return (
    <div className="inline-flex rounded-md shadow-sm" role="group">
      <button
        type="button"
        onClick={openGoogleMaps}
        className={`inline-flex items-center ${sizeClasses[size]} font-medium rounded-l-md ${variantClasses[variant]} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors`}
        title={`View ${label} on Google Maps`}
      >
        <MapPin className={`${iconSizes[size]} mr-1`} />
        {label}
      </button>
      <button
        type="button"
        onClick={openNavigation}
        className={`inline-flex items-center ${sizeClasses[size]} font-medium rounded-r-md border-l ${variant === 'outline' ? 'border-l-blue-600' : 'border-l-white/30'} ${variantClasses[variant]} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors`}
        title="Get directions"
      >
        <Navigation className={iconSizes[size]} />
      </button>
    </div>
  );
};

export default MapPinButton;
